module.exports = __webpack_public_path__ + "img/empty_food.52245e93.png";